import { render, staticRenderFns } from "./headertabthree.vue?vue&type=template&id=0772ac0e&scoped=true&"
import script from "./headertabthree.vue?vue&type=script&lang=js&"
export * from "./headertabthree.vue?vue&type=script&lang=js&"
import style0 from "./headertabthree.vue?vue&type=style&index=0&id=0772ac0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772ac0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0772ac0e')) {
      api.createRecord('0772ac0e', component.options)
    } else {
      api.reload('0772ac0e', component.options)
    }
    module.hot.accept("./headertabthree.vue?vue&type=template&id=0772ac0e&scoped=true&", function () {
      api.rerender('0772ac0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/headertabthree.vue"
export default component.exports